import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../../store";
import {
  storeStarterSelectAsideShow,
  storeStarterSelectSidebarShow,
  storeStarterSetLayout,
} from "../datasources/_starter.layout.store.slice";

export const useStarterHeaderController = () => {
  const dispatch = useDispatch();
  const sidebarShow = useTypedSelector(storeStarterSelectSidebarShow);
  const asideShow = useTypedSelector(storeStarterSelectAsideShow);

  const setSidebarShow = (sidebarShow: boolean) => {
    dispatch(storeStarterSetLayout({ sidebarShow: sidebarShow }));
  };

  const setAsideShow = (asideShow: boolean) => {
    dispatch(storeStarterSetLayout({ asideShow: asideShow }));
  };

  return {
    state: {
      sidebarShow,
      asideShow,
    },
    action: {
      setSidebarShow,
      setAsideShow,
    },
  };
};
